import { SsoModalActionType } from '../actiontype/sso-modal.actiontype';
import { UserAction } from '../constants/user-action.constant';
import { setMsisdn, hideHeader, hideFooter } from './app.action';
import { openErrorModal } from './app-modal.action';
import { fetchDndMappingAndPreferences, fetchDndMapping } from './dnd-registration.action';
import Modals from '../constants/modal.enum';
import UtilService from '../services/util.service';
import { AppModalConstant } from '../constants/app-modal.constant';
import { setUserPreference } from './dnd-app.action';
import { setSelectedNumber } from './authorization.action';

//set selected si number
export function setSelectedSiNumber(siNumber) { return { type: SsoModalActionType.SET_SELECTED_SI_NUMBER, payload: siNumber } };

//set selected lob
export function setSelectedLob(lob) { return { type: SsoModalActionType.SET_SELECTED_LOB, payload: lob } };

// on sso details submission
export const proceedAccToUserPreference = selectedNumber => (dispatch, getState) => {
    const state = getState();
    const userPreference = state.dndapp.userPreference;
    dispatch(setSelectedNumber(selectedNumber));
    // dispatch(closeModal());
    switch (userPreference) {
        case UserAction.MOBILE_REGISTRATION:
        case UserAction.FIXEDLINE_REGISTRATION:
            dispatch(openRegistrationsPage());
            break;
        case UserAction.COMPLAINT:
            dispatch(openComplainsPage());
            break;
        default:
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            break;
    }
}

export const openRegistrationsPage = () => dispatch => {
    dispatch(fetchDndMappingAndPreferences());
    dispatch(hideHeader());
    dispatch(hideFooter());
}

export const openComplainsPage = () => dispatch => {
    dispatch(fetchDndMapping());
    dispatch(hideHeader());
    dispatch(hideFooter());
}

